<template lang="pug">
  .navbar.navbar-light(
    :class="{float:float}"
    :style="{opacity:opacity}"
    ref="navbarTop"
    )
    transition(name="fade")
      .white-modal(
        v-if="modalMode",
        @click="unfocusInput()"
        )
    .navbar-wrapper
      .left
        .navbar-logo
          img(src="@/assets/icons/17life_logo.svg")
          a(@click="navigateToHome",href="javascript:void(0);")
      .center
        .navbar-search-bar.light(:class="{'input-focus':modalMode}")
          img.search-default(
            src="@/assets/icons/ic_search_sm.svg",
            v-if="!modalMode"
            )
          form(
            @submit.prevent="submitSearch()",
            ref="form",
            action="."
          )
            input(
              @focus="focusInput()",
              v-model="inputText",
              type="search",
              maxlength="18",
              placeholder="輸入關鍵字進行搜尋",
            )
          img.search-action.not-blue-highlight(
            src="@/assets/icons/ic_search_sm.svg",
            v-if="inputText && modalMode",
            @click="submitSearch()"
            )
      .right
        //- .navbar-search.ic-sm(@click="searchClick")
        //-   img(src="@/assets/icons/ic_search.svg")
        //- .navbar-favorite.ic-sm(@click="favoriteListClick")
        //-   img(src="@/assets/icons/ic_favorite.svg")
        //- .navbar-member.ic-sm(@click="memberClick")
        //-   img(class="head",:src="memberPic",v-if="memberAuthentication")
        //-   img(src="@/assets/icons/ic_member.svg",v-else)
        .navbar-messege.ic-sm
          img(src="@/assets/icons/ic_events_sm_light.svg")
          a(
            :href="eventLink",
            target="_blank")
</template>

<script>
import axios from 'axios'
export default {
  name: 'navbar',
  components:{
  },
  props:{
    opacity:{
      type: Number,
      required: false,
      default: function(){
        return 1;
      }
    },
    float:{
      type: Boolean,
      required: false,
      default: false
    },
  },
  data(){
    return{
      modalMode: false,
      pageScrollFixed: false,
      inputText: '',
    }
  },
  computed:{
    eventLink: function(){
      // 從axios抓取根網域
      var baseURL = axios.defaults.baseURL;
      // 組合成新的URL
      var url = baseURL+'Event/ThemeCurationChannelMobile';
      return url
    }
  },
  methods:{
    // 回首頁
    navigateToHome(){
      this.$router.push({name:'home'})
    },
    // 輸入欄的input:focus動作
    focusInput(){
      this.modalMode = true;
      this.pageScrollFixed = true;
      this.$emit('focusInput',true)
    },
    unfocusInput(){
      this.modalMode = false;
      this.pageScrollFixed = false;
      this.$emit('unfocusInput',false);
    },
    // 送出搜尋
    submitSearch(){
      if(this.inputText.length>0){
        // 從axios抓取根網域
        var baseURL = axios.defaults.baseURL;
        // 組合成新的URL
        var url = baseURL+'m/SearchResult?keywords='+this.inputText;
        this.unfocusInput();
        // 開啟新視窗顯示搜尋結果
        location.href = url
      }else{
        return
      }
      // 清空搜尋列內容
      this.inputText = ''
    },
  },
  watch:{
    pageScrollFixed(){
      // 切換捲動鎖定
      if(this.pageScrollFixed){
        document.body.classList.add('scroll-fixed');
      }else{
        document.body.classList.remove('scroll-fixed');
      }
    }
  }
}
</script>

